import { render } from "./Physicians.vue?vue&type=template&id=5e643905&ts=true"
import script from "./Physicians.ts?vue&type=script&lang=ts&external"
export * from "./Physicians.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__